import { Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import { replaceMainSiteLinkHostname } from "../../services/Utils";

const VITE_CHAT_HOST =
  import.meta.env.VITE_CHAT_HOST || "https://chat.988lifeline.org";

const SessionInvalidPage = () => {
  const { t } = useTranslation("common");
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
        textAlign: "center",
        px: 3,
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontSize: "28px",
          fontWeight: "bold",
          color: theme.palette.error.main,
          mb: 2,
        }}
      >
        {t("sessionInvalid.title")}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          fontSize: "18px",
          mb: 3,
          maxWidth: "600px",
          lineHeight: 1.6,
        }}
      >
        {t("sessionInvalid.message")}
      </Typography>

      <Button
        disableRipple
        variant="contained"
        href={replaceMainSiteLinkHostname(t("chatHomeUrl"), VITE_CHAT_HOST)}
        sx={{
          mt: 2,
          px: 4,
          py: 1.5,
          fontSize: "16px",
          fontWeight: "bold",
          borderRadius: "25px",
          textTransform: "none",
        }}
      >
        {t("sessionInvalid.button")}
      </Button>
    </Box>
  );
};

export default SessionInvalidPage;
